import * as Yup from "yup";
import React from "react";
import { Button, Form, Modal, ToastContainer } from "react-bootstrap";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { useTestUserStore } from "../store/testUserStore";

const AssignGameIdModal = ({ show, handleClose }) => {
  const { setNormalToTestUser, loading } = useTestUserStore();

  const formik = useFormik({
    initialValues: {
      gameId: "",
      email: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      gameId: Yup.number().required("Game ID is required"),
      email: Yup.string().required("Email is required"),
    }),
    onSubmit: async (values) => {
      try {
        const payload = {
          gameId: values?.gameId,
          email: values?.email,
        };

        const res = await setNormalToTestUser(payload);
        if (res?.response?.status === 404 || res?.response?.status === 400) {
          toast.error(res?.response?.data?.data?.message);
        } else {
          formik.resetForm();
          handleClose();
        }
      } catch (error) {
        toast.error("Error Setting Game");
      }
    },
  });
  return (
    <>
      <ToastContainer />
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Test User</Modal.Title>
        </Modal.Header>
        <Form onSubmit={formik.handleSubmit} noValidate>
          <Modal.Body>
            <Form.Group controlId="validationCustom01">
              <Form.Label>Email</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Email..."
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                isInvalid={formik.touched.email && formik.errors.email}
              />

              {formik.touched.email && formik.errors.email ? (
                <div className="invalid-feedback d-block">
                  {formik.errors.email}
                </div>
              ) : null}
            </Form.Group>
            <Form.Group controlId="validationCustom03">
              <Form.Label>Game ID</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Game ID..."
                name="gameId"
                value={formik.values.gameId}
                onChange={formik.handleChange}
                isInvalid={formik.touched.gameId && formik.errors.gameId}
              />
              {formik.touched.gameId && formik.errors.gameId ? (
                <div className="invalid-feedback d-block">
                  {formik.errors.gameId}
                </div>
              ) : null}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            {loading ? (
              <button className="btn btn-primary" type="button" disabled>
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </button>
            ) : (
              <button className="btn btn-primary" type="submit">
                Set
              </button>
            )}
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default AssignGameIdModal;
